// frontend/shared-ui/src/auth/PermissionRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { usePermissions, checkPermission } from "./PermissionsContext";

export default function PermissionRoute({
  permission,
  anyOf,
  allOf,
  redirect = "/unauthorized",
}) {
  const { permissions } = usePermissions();

  let allowed = false;
  if (permission) allowed = checkPermission(permissions, permission);
  else if (anyOf?.length)
    allowed = anyOf.some((p) => checkPermission(permissions, p));
  else if (allOf?.length)
    allowed = allOf.every((p) => checkPermission(permissions, p));
  else allowed = true;

  if (!allowed) return <Navigate to={redirect} replace />;
  return <Outlet />;
}
